import Vue from "vue";
import Vuex from "vuex";
import { default as AXIOS } from "@/assets/js/axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {
    sendMessage({ commit }, data) {
      if (!data) {
        return Promise.reject("Null data");
      }
      for (let key in data) {
        const val = data[key];
        if (!val) {
          return Promise.reject(`Missing data: ${key}:${val}`);
        }
      }
      const axios = AXIOS.axios;
      return new Promise((resolve, reject) => {
        return axios
          .post(
            `${process.env.VUE_APP_API_ENDPOINT}${
              process.env.VUE_APP_BASE_URI
            }/notifications`,
            Object.assign(
              {
                type: "email",
                source: "proletariatstudio.com"
              },
              data
            )
          )
          .then((data: any) => {
            console.log(data);
            return resolve(data);
          })
          .catch((err: any) => {
            console.log(err);
            return reject(err);
          });
      });
    }
  }
});
